import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "@mui/material";
import { SET_ERROR_PROMPT_REPORTING_PAGE } from "../../store/actionTypes/reportingActionType";

const ReportingErrorPrompt = () => {
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation();

  const {
    isErrorPromptReportingPage: isError,
    errorMessageReportingPage: errorMessage,
  } = useSelector((state) => state.reporting);

  const handleClose = (e, reason) => {
    dispatch({ type: SET_ERROR_PROMPT_REPORTING_PAGE, payload: false });
  };

  return (
    isError && (
      <Alert
        sx={{ my: 2 }}
        severity="error"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{tCommon("errorPromptTitle")}</AlertTitle>
        {errorMessage}
      </Alert>
    )
  );
};

export default ReportingErrorPrompt;
